import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { useParams } from 'react-router-dom';
import Survey from './containers/Survey';
import createStore from './store';

const SurveyApp = () => {
  const { token } = useParams();
  useEffect(() => {
    const unloadHandler = (e) => {
      const confirmationMessage = '';
      (e || window.event).returnValue = confirmationMessage; // Gecko + IE
      return confirmationMessage;                            // Webkit, Safari, Chrome
    };
    window.addEventListener('beforeunload', unloadHandler);
    return () => window.removeEventListener('beforeunload', unloadHandler);
  }, []);
  return (
    <Provider store={createStore(token)}>
      <Survey />
    </Provider>
  );
};

export default SurveyApp;
